import { Triangle, triangleWidth, triangleY } from './triangle';
import { getBarWidth, getRangeEvolution } from './bank-history-chart-utils';
import { chartPadding } from './bank-history-chart';
import { BalanceRangeTooltip } from './balance-range-tooltip';
import { useBankHistorySelection } from './use-bank-history-selection';
import { activeBarBonusWidth } from './bar-with-tooltip';
import { BankHistory } from '@algoan/dashboard/model';

interface CustomBrushProps {
  cursor: string;
  height: number;
  width: number;
  x: number;
}

interface CustomRangeProps {
  data: BankHistory[];
  graphWidth: number;
}

export const CustomRange: React.FC<CustomRangeProps> = ({ data, graphWidth, ...props }) => {
  const brushProps = props as CustomBrushProps;
  const { originData, endData } = useBankHistorySelection();
  const dataLength = data.length;
  const barSize = getBarWidth({
    rangeWidth: brushProps.width,
    iteration: dataLength,
    startIndex: originData?.index,
    endIndex: endData?.index,
  });
  const totalTransactions = getRangeEvolution({ originData, endData });

  return (
    <>
      {originData && endData && (
        <BalanceRangeTooltip
          {...brushProps}
          originData={originData}
          endData={endData}
          totalTransactions={totalTransactions}
          graphWidth={graphWidth}
        />
      )}
      <Triangle
        width={triangleWidth}
        x={brushProps.x + (brushProps.width - triangleWidth) / 2}
        y={chartPadding.top - triangleY}
      />
      <rect
        {...brushProps}
        width={brushProps.width - barSize - activeBarBonusWidth * 2}
        x={brushProps.x + barSize / 2 + 1}
      />
    </>
  );
};
